/**
 * Die Zeichen der Tab-Leiste und der Statistik — als Striche, nicht als
 * Schriftart.
 *
 * Eine Symbolschrift wäre ein halbes Megabyte für fünfundzwanzig Zeichen und in zehn
 * Jahren ein Migrationsabend. Fünfundzwanzig Pfade sind ein paar Zeilen und altern
 * nicht. Alle im selben Raster (24), alle als Kontur in der Textfarbe: So
 * bleibt die Regel des Hauses gewahrt, dass alles Warme im Bild aus der
 * Tiefenskala kommt und den Daten gehört.
 */

/**
 * Die Liste trägt das Tiefenprofil, nicht drei Striche.
 *
 * Drei Striche heissen überall „Menü". Das Profil ist dasselbe Zeichen, das
 * die App im Symbol führt und jede Listenzeile als Glyph trägt — es sagt
 * „Tauchgänge", nicht „irgendeine Liste".
 */
export const SYMBOLE = {
  liste: ['M3 6.5l4.2 9.5 3.4 1.4 3.4-1.4 3 2.4L21 6.5'],
  karte: [
    'M12 3a9 9 0 100 18 9 9 0 000-18',
    'M3 12h18',
    'M12 3c2.6 2.9 2.6 15.1 0 18',
    'M12 3c-2.6 2.9-2.6 15.1 0 18',
  ],
  statistik: ['M5 20v-7', 'M12 20V4', 'M19 20v-11'],
  checkin: [
    'M3.5 5.5h17v13h-17z',
    'M10 12.4a1.9 1.9 0 100-3.8 1.9 1.9 0 000 3.8z',
    'M7.2 15.8c.4-1.5 1.5-2.4 2.8-2.4s2.4.9 2.8 2.4',
    'M15.5 10.5H18',
    'M15.5 13.5H18',
  ],
  stammdaten: ['M3.5 5.5h17v13h-17z', 'M3.5 10.5h17', 'M9.5 10.5v8'],
  verorten: [
    'M12 21.2c4.4-4.6 6.6-8 6.6-10.4a6.6 6.6 0 10-13.2 0c0 2.4 2.2 5.8 6.6 10.4z',
    'M12 12.7a2 2 0 100-4 2 2 0 000 4z',
  ],
  sync: [
    'M19.5 12a7.5 7.5 0 01-12.9 5.2',
    'M4.5 12a7.5 7.5 0 0112.9-5.2',
    'M17.6 3.2v3.6H14',
    'M6.4 20.8v-3.6H10',
  ],
  laden: ['M12 4v11', 'M8 11.2l4 4 4-4', 'M4.5 19.5h15'],
  mehr: ['M4.5 4.5h6v6h-6z', 'M13.5 4.5h6v6h-6z', 'M4.5 13.5h6v6h-6z', 'M13.5 13.5h6v6h-6z'],
  zurueck: ['M15 4.5L7.5 12l7.5 7.5'],
  plus: ['M12 5v14', 'M5 12h14'],
  schliessen: ['M6 6l12 12', 'M18 6L6 18'],
  suche: ['M11 4.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13z', 'M15.8 15.8L20.5 20.5'],
  haken: ['M5 12.5l4.5 4.5L19 7.5'],

  // Die Zeichen der Statistik. Sie stehen neben einer Zahl, nicht neben einem
  // Wort — deshalb muessen sie allein sagen, worum es geht.
  zeit: ['M12 3.6a8.4 8.4 0 100 16.8 8.4 8.4 0 000-16.8', 'M12 7.4V12l3.3 2.3'],
  tiefe: [
    // Oben die Oberflaeche, darunter der Weg nach unten — dieselbe Achse, an
    // der die ganze App haengt.
    'M3.2 6c1.9-1.7 3.3-1.7 5.2 0s3.3 1.7 5.2 0 3.3-1.7 5.2 0',
    'M12 10v8.6',
    'M8.4 15.2l3.6 3.6 3.6-3.6',
  ],
  rekord: [
    'M8 4.2h8v4.3a4 4 0 01-8 0z',
    'M8 5.6H5.3v1.3a3 3 0 003 3',
    'M16 5.6h2.7v1.3a3 3 0 01-3 3',
    'M12 12.6v4.2',
    'M8.4 19.8h7.2',
  ],
  reise: [
    'M4.4 15.6h15.2l-2.1 4.4H6.5z',
    'M12 15.6V3.6',
    'M12 5.4l6.1 8.2H12',
  ],
  buddy: [
    'M9.1 9.2a2.6 2.6 0 100-5.2 2.6 2.6 0 000 5.2',
    'M3.4 19.8c0-3.4 2.6-5.7 5.7-5.7s5.7 2.3 5.7 5.7',
    'M16.4 8.6a2.2 2.2 0 100-4.4 2.2 2.2 0 000 4.4',
    'M15.6 13.9c2.9.3 5 2.5 5 5.4',
  ],

  // Die Zeichen der Detailseite. `schnitt` ist das Profil der Liste mit einer
  // Linie hindurch — die Durchschnittstiefe ist genau das: der Strich, um den
  // die Kurve pendelt. Dasselbe Zeichen wie fuer die Maximaltiefe zu nehmen,
  // waere zweimal dasselbe Bild fuer zwei verschiedene Zahlen.
  schnitt: ['M3 6.5l4.2 9.5 3.4 1.4 3.4-1.4 3 2.4L21 6.5', 'M8.6 12.6h6.8'],
  temperatur: [
    'M14 13.7V5.4a2 2 0 00-4 0v8.3a3.4 3.4 0 104 0z',
    'M14 8.6h2.4',
    'M14 11.2h2.4',
  ],
  // Ein Reisepass ist kein Segelboot. Der Umschlag mit dem Wappenkreis darauf
  // ist das, was auf dem Tresen liegt.
  pass: [
    'M6 3.6h12v16.8H6z',
    'M12 12.4a2.9 2.9 0 100-5.8 2.9 2.9 0 000 5.8',
    'M9.2 16.6h5.6',
  ],
  medizin: ['M12 5.5v13', 'M5.5 12h13'],
  kalender: [
    'M4.5 6.4h15v13.2h-15z',
    'M4.5 10.4h15',
    'M8.6 3.8v3.4',
    'M15.4 3.8v3.4',
  ],
  flasche: [
    'M9 8.8h6v9.4a2.6 2.6 0 01-2.6 2.6h-.8A2.6 2.6 0 019 18.2z',
    'M11.4 8.8V5.6h1.2v3.2',
    'M10.3 4.4h3.4',
  ],
};

/**
 * Dasselbe Symbol als Zeichenkette.
 *
 * Die Statistik baut ihre Seite als HTML-Text, nicht als DOM — ohne diese
 * Fassung stuende dort eine zweite, handgeschriebene Kopie der Pfade, und
 * zwei Fassungen laufen unweigerlich auseinander.
 */
export function symbolHtml(name, groesse = 24) {
  const pfade = (SYMBOLE[name] ?? []).map((d) => `<path d="${d}"/>`).join('');
  return `<svg viewBox="0 0 24 24" width="${groesse}" height="${groesse}" fill="none"`
    + ` stroke="currentColor" stroke-width="1.5" stroke-linecap="round"`
    + ` stroke-linejoin="round" aria-hidden="true" class="symbol symbol-${name}">`
    + `${pfade}</svg>`;
}

/**
 * Ein Symbol als SVG-Element.
 *
 * `aria-hidden`, weil daneben immer ein Wort steht: Ein Bildschirmleser soll
 * „Karte" hören, nicht „Karte Grafik Karte".
 */
export function symbol(name, groesse = 24) {
  const raum = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(raum, 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('width', String(groesse));
  svg.setAttribute('height', String(groesse));
  svg.setAttribute('fill', 'none');
  svg.setAttribute('stroke', 'currentColor');
  svg.setAttribute('stroke-width', '1.5');
  svg.setAttribute('stroke-linecap', 'round');
  svg.setAttribute('stroke-linejoin', 'round');
  svg.setAttribute('aria-hidden', 'true');
  svg.classList.add('symbol', `symbol-${name}`);
  for (const d of SYMBOLE[name] ?? []) {
    const pfad = document.createElementNS(raum, 'path');
    pfad.setAttribute('d', d);
    svg.append(pfad);
  }
  return svg;
}
